(function () {
    'use strict';

    angular
        .module('directives.pointsOfFocus', ['pointsOfFocusModule'])
        .directive('selectPointsOfFocus', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                selectedPointsOfFocus: '=',
                allPointsOfFocus: '=',
                whenUpdatedPointsOfFocus: '&',
                readOnly: '@'
            },
            controller: ['$scope', '$modal', function ($scope, $modal) {

                $scope.selectPrinciples = function () {

                    // Modal to select person
                    var modalScope                   = $scope.$new(true);
                    modalScope.selectedPointsOfFocus = _.cloneDeep($scope.selectedPointsOfFocus);
                    modalScope.allPointsOfFocus      = $scope.allPointsOfFocus;
                    modalScope.readOnly              = $scope.readOnly === 'true';
                    modalScope.modalTitle            = modalScope.readOnly ? 'Selected Points of Focus' : 'Select Points of Focus';

                    var selectPointsOfFocusModal = $modal({
                        scope: modalScope,
                        template: '/app/shared/grc/pointsOfFocus/selectPointsOfFocusModal.tpl.html',
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        selectPointsOfFocusModal.$promise.then(selectPointsOfFocusModal.hide);
                        modalScope.$destroy();
                    }

                    modalScope.okModal = function () {
                        $scope.whenUpdatedPointsOfFocus({ pointsOfFocus: modalScope.selectedPointsOfFocus });
                        modalScope.hideModal();
                        modalScope.$destroy();
                    }
                };
            }],
            link: function (scope, elem) {
                elem.bind('click', function () {
                    scope.selectPrinciples();
                });
            }
        }
    }
})();